import SectionHeading from '@/components/base/SectionHeading';

export default function CooperationIntro() {
  return (
    <section className="bg-background-50 py-14 md:py-24">
      <div className="w-full px-5 md:px-8 lg:px-12">
        <div className="max-w-[1400px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
          <div className="lg:col-span-6">
            <SectionHeading
              kicker="Partnership"
              title="把线索变成公共价值，需要更多专业协作者"
              description="平台擅长的是汇集信息、梳理时间线与整理疑点；实地采访、法律审读与学术研究，需要专业伙伴一起完成。我们把合作流程写得足够清楚，也希望合作的边界足够清楚。"
            />
            <ul className="mt-8 space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-primary-500 mt-1"></i>
                <p className="text-sm leading-relaxed text-foreground-700">
                  合作不代表对选题结论的共同承诺，任何一方发现事实偏差都可以提出复核。
                </p>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-primary-500 mt-1"></i>
                <p className="text-sm leading-relaxed text-foreground-700">
                  信源信息与合作方严格隔离，平台不会向合作方提供任何可识别信源身份的资料。
                </p>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-primary-500 mt-1"></i>
                <p className="text-sm leading-relaxed text-foreground-700">
                  所有合作都以书面约定明确范围、署名方式与保密义务后再启动。
                </p>
              </li>
            </ul>
            <a
              href="#apply"
              className="mt-9 inline-flex items-center gap-2 bg-foreground-950 hover:bg-primary-500 text-background-50 text-sm font-medium px-6 py-3.5 rounded-md transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-links-line"></i>
              直接发起合作申请
            </a>
          </div>

          <div className="lg:col-span-6">
            <div className="w-full aspect-[4/3] rounded-lg overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=minimal%20editorial%20still%20life%20of%20two%20translucent%20glass%20puzzle%20pieces%20meeting%20on%20a%20warm%20cream%20paper%20background%2C%20soft%20amber%20side%20light%2C%20collaboration%20and%20partnership%20concept%2C%20clean%20composition%2C%20subtle%20shadows%2C%20no%20text&width=1100&height=825&seq=st-coop-2026&orientation=landscape"
                alt="两块玻璃拼图在暖色纸面上相接，象征合作与共建"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}